import EditOrganisationForm from './EditOrganisationForm'
import enhance from './EditOrganisationForm.enhancer.js'

export default enhance(EditOrganisationForm)



// WEBPACK FOOTER //
// ./src/components/organisms/EditOrganisationForm/index.js